export default "__VITE_ASSET__CHmHLmRj__"